import { useQuery } from "@apollo/client";
import {
  GetMeetingNewPageQueryQuery,
  GetMeetingNewPageQueryQueryVariables,
} from "types/graphql-schema";

import MeetingViewSidebar from "@apps/meeting-new/components/meeting-sidebar/meeting-view-sidebar";
import getMeetingQuery from "@apps/meeting-new/graphql/get-meeting-query";

// The profile 1-on-1 tab shows the same sidebar as the 1-on-1 meeting page
// (My Notes, Coaching Insights, Work History, Ask AI), scoped to the focused
// meeting. We reuse MeetingViewSidebar directly so the two stay in sync.
const ProfileOneononeSidebar = ({
  meetingId,
  useRollingWorkHistoryDateRange,
}: {
  meetingId: number | null;
  useRollingWorkHistoryDateRange: boolean;
}) => {
  const { data } = useQuery<
    GetMeetingNewPageQueryQuery,
    GetMeetingNewPageQueryQueryVariables
  >(getMeetingQuery, {
    variables: { meetingId: meetingId ?? -1 },
    skip: meetingId === null,
  });
  const meeting = data?.meeting;

  if (!meeting) return null;

  return (
    <MeetingViewSidebar
      meeting={meeting}
      sidebarExpandedUiPreferenceKey="profileSidebarExpanded"
      useRollingWorkHistoryDateRange={useRollingWorkHistoryDateRange}
    />
  );
};

export default ProfileOneononeSidebar;
